import { useState, useEffect, useRef } from "react";
import service1_1 from '../assets/service1.1.png'
import service1_2 from '../assets/service1.2.png'
import service1_3 from '../assets/service1.3.png'
import service1_4 from '../assets/service1.4.png'
import service1_5 from '../assets/service1.5.png'

// Данные услуг (фото)
const servicesData = [
  {
    id: 1,
    image: service1_1,
  },
  {
    id: 2,
    image: service1_2,
  },
  {
    id: 3,
    image: service1_3,
  },
  {
    id: 4,
    image: service1_4,
  },
  {
    id: 5,
    image: service1_5,
  },
];

export default function WaterCleanSection({ t }) {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const sectionRef = useRef(null);

  const servicesTranslations = t?.waterclean?.services || [];

  const services = servicesData.map((item, index) => ({
    ...item,
    title: servicesTranslations[index]?.title || "",
    description: servicesTranslations[index]?.description || "",
  }));

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  // Блокировка скролла при открытой модалке
  useEffect(() => {
    if (selectedService) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [selectedService]);

  return (
    <section ref={sectionRef} id="waterclean" className="py-6 md:py-6">
      <div className="mx-auto max-w-7xl max-sm::w-full px-4 md:px-6">

        {/* =========================
            БЛОК 1 — Заголовок
        ========================== */}

        <div
          className={`
            border-l-2 md:border-l-4
            border-[#0FA4E8]
            bg-gray-50
            p-5 md:p-10
            transition-all duration-700
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
          `}
        >

          <h2 className="mb-4 text-2xl md:text-4xl font-black uppercase text-[#0B3B6F]">
            {t?.waterclean?.title || ""}
          </h2>

          <p className="max-w-3xl text-base md:text-lg leading-relaxed text-slate-600">
            {t?.waterclean?.description || ""}
          </p>
        </div>


        {/* =========================
            БЛОК 2 — Цитата + Услуги
        ========================== */}

        <div
          className={`
            mt-10
            border-l-2 md:border-l-4
            border-[#0B3B6F]
            bg-gray-50
            p-3 
            transition-all duration-700 delay-150
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
          `}
        >
          {/* Цитата */}
          <div className="relative mb-10">
            <div className="absolute -top-4 -left-2 text-2xl md:text-7xl text-[#0FA4E8]/10 font-serif select-none">"</div>
            <p className="relative text-sm md:text-xl font-semibold text-[#0B3B6F] italic pl-3 md:pl-10">
              {t?.waterclean?.quote || ""}
            </p>
          </div>

          {/* Заголовок услуг */}
          <h3 className="mb-8 text-xl px-6 md:text-2xl font-black uppercase text-[#0B3B6F]">
            {t?.timelineTitle || "Ծառայություններ"}
          </h3>


          {/* =========================
              GRID услуг
          ========================== */}

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {services.map((service, idx) => (
              <div key={service.id} className="group relative">

                {/* CARD */}
                <div
                  onClick={() => setSelectedService(service)}
                  className="
                    relative
                    h-[220px] md:h-[260px]
                    overflow-hidden
                    rounded-[24px]
                    border border-white/10
                    shadow-md
                    transition-all duration-500
                    hover:-translate-y-1 hover:shadow-lg
                    cursor-pointer
                  "
                  style={{
                    backgroundImage: `
                      linear-gradient(
                        0deg,
                        rgba(11,59,111,0.85) 0%,
                        rgba(11,59,111,0.7) 0%,
                        rgba(11,59,111,0.4) 40%,
                        rgba(11,59,111,0.15) 100%
                      ),
                      url("${service.image}")
                    `,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                >
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-[#0B3B6F]/0 transition-all duration-500 group-hover:bg-[#0B3B6F]/10" />

                  {/* CONTENT */}
                  <div className="relative z-10 flex h-full flex-col justify-between p-5 md:p-6">
                    {/* Номер */}
                    <span className="text-5xl md:text-7xl font-black leading-none text-white/50 transition-all duration-300 ">
                      {String(idx + 1).padStart(2, '0')}
                    </span>

                    {/* Название */}
                    <p className="text-sm md:text-base font-black leading-tight text-white transition-colors duration-300 ">
                      {service.title}
                    </p>
                  </div>
                </div>

                {/* ARROW между карточками */}
                {idx < services.length - 1 && (
                  <div className="hidden lg:flex absolute top-1/2 -right-3 z-20 h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full bg-white shadow-sm pointer-events-none">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0FA4E8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M5 12h14" />
                      <path d="m13 6 6 6-6 6" />
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* =========================
          МОДАЛЬНОЕ ОКНО
      ========================== */}
      {selectedService && (
        <div
          className="fixed inset-0 z-50 flex rounded-none items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-[fadeIn_0.3s_ease-out]"
          onClick={() => setSelectedService(null)}
        >
          <div
            className="relative w-full max-w-lg bg-white rounded-[32px] overflow-hidden shadow-2xl animate-[zoomIn_0.4s_ease-out]"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Изображение */}
            <div className="relative h-48 sm:h-56">
              <img
                src={selectedService.image}
                alt={selectedService.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B3B6F]/80 to-transparent" />
              
              {/* Номер в модалке */}
              <div className="absolute top-4 left-4 text-5xl font-black text-white/30">
                {String(services.findIndex(s => s.id === selectedService.id) + 1).padStart(2, '0')}
              </div>
            </div>

            {/* Контент */}
            <div className="p-6 sm:p-8">
              <h3 className="text-xl sm:text-2xl font-black text-[#0B3B6F] mb-3">
                {selectedService.title}
              </h3>
              <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
                {selectedService.description}
              </p>
            </div>

            {/* Кнопка закрыть */}
            <button
              onClick={() => setSelectedService(null)}
              className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/30 transition-all duration-300 hover:scale-110"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      )}
    </section>
  );
}